import { Breadcrumb } from 'react-breadcrumbs';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import CalendarEventSection from './CalendarEventSection';
import { useCalendarEventTemplate } from '../../../../../hooks/queries/calendar-event-templates';
import { correctPath } from 'libraries/gem';

const CalendarEventTemplateDetails = () => {
  const { id } = useParams<{ id: string }>();

  const { data: calendarEventTemplate } = useCalendarEventTemplate(id);

  return (
    <Breadcrumb
      data={{
        title: 'Details',
        pathname: correctPath(`/app/calendar-event-templates/${id}/details`),
      }}
    >
      <div className="calendar-event-template-details-container">
        <Helmet>
          <title>Details | {calendarEventTemplate?.name} | Gem Scheduling</title>
        </Helmet>
        <CalendarEventSection />
      </div>
    </Breadcrumb>
  );
};

export default CalendarEventTemplateDetails;
